import { render, staticRenderFns } from "./SendImageMap.vue?vue&type=template&id=9d183df2&scoped=true&"
import script from "./SendImageMap.vue?vue&type=script&lang=js&"
export * from "./SendImageMap.vue?vue&type=script&lang=js&"
import style0 from "./SendImageMap.vue?vue&type=style&index=0&id=9d183df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d183df2",
  null
  
)

export default component.exports